import { useEffect, useState } from 'react'
import { InfoLandingView } from '@/components/info/InfoLandingView'

/**
 * Public `/info` landing page (Xendrel). Owns the window IO — document title,
 * smooth anchor scrolling, and the scroll flag that drives the sticky-nav
 * backdrop — and hands the derived state to the pure {@link InfoLandingView}.
 */
export default function InfoPage() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const prevTitle = document.title
    document.title = 'Xendrel — On-premise decision intelligence platform'
    const root = document.documentElement
    const prevScrollBehavior = root.style.scrollBehavior
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!prefersReducedMotion) root.style.scrollBehavior = 'smooth'

    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      root.style.scrollBehavior = prevScrollBehavior
      document.title = prevTitle
    }
  }, [])

  return <InfoLandingView scrolled={scrolled} />
}
